import {makeStyles} from '@material-ui/core/styles';

export const settingStyles = makeStyles({
    elementWrapper: {
        marginTop: '10px',
        marginBottom: '0px',
    },
    elementTypeTime: {
        marginTop: '5px',
        margin: '15px',
        minWidth: '130px',
    },
    elementTime: {
        marginTop: '5px',
        margin: '15px',
        maxWidth: '120px'
    },
    elementAddress: {
        margin: '5px',
        minWidth: '250px'
    },
    title:
    {
        align: 'left',
        display: 'flex',
        marginLeft: '1%'
    }
});